import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HttpService } from "../../services/HttpService";
import Store from "..";

const initialState = {
  surveysList: [],
  search: "",
  pageIndex: 1,
  pageTotal: 0,
  itemsPerPage: Number(process.env.REACT_APP_PAGE_LIST) || 5,
  order: "name",
  orderAs: "asc",
  apiError: "",
};

/**
 * fetch surveys data
 */
export const getSurveyList = () => async (dispatch: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    const search = Store.getState().surveys.search;
    const orderAs = Store.getState().surveys.orderAs;
    const order = Store.getState().surveys.order;
    const itemsPerPage = Store.getState().surveys.itemsPerPage;
    const pageIndex = Store.getState().surveys.pageIndex;

    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/surveyList?itemsPerPage=${itemsPerPage}&page=${pageIndex}&orderBy=${order}&orderAs=${orderAs}&search=${search}`
    );

    if (list.data) {
      dispatch(updateSurvey(list.data.result));
      dispatch(
        updatePageTotal(Math.ceil(Number(list.data.totalItems) / itemsPerPage))
      );
    }
  } catch (e) {
    console.log("fetch Surveys:", e);
  }
};

/**
 * update pagination number
 */
export const updatePageIndex = (pageIndex: Number) => async (dispatch: any) => {
  try {
    dispatch(updatePage(pageIndex));
  } catch (e) {
    console.log("update search value:", e);
  }
};

export const searchLoadSurvey = (search: string) => async (dispacth: any) => {
  try {
    await dispacth(updateSearchSurvey(search));
    await dispacth(getSurveyList());
  } catch (e) {
    console.log("Search surveys", e);
  }
};

/**
 * Get survey form fields
 */
export const getSurveyFormField = (surveyId: any) => async (dispatch: any) => {
  try {
    const result = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/event/surveyFormList/${surveyId}`
    );
    if (result.data) {
      return result.data.result;
    }
  } catch (e) {
    console.log("Get survey form fields:", e);
  }
};

/**
 * Post survey data
 */
export const saveSurvey =
  (citizenId: any, eventId: any, surveyId: any, formData: any) =>
  async (dispatch: any) => {
    try {
      const result = await HttpService.post(
        `${process.env.REACT_APP_API}/t4event/api/v01/guest/${citizenId}/event/${eventId}/survey/${surveyId}`,
        formData
      );
      if (result.data) {
        return result.data.attendanceId;
      }
    } catch (e: any) {
      dispatch(updateServerError(e.response.data.result));
    }
  };

/**
 * delete survey answers by Id.
 */
export const deleteSurveyAnswersById =
  (eventId: string, guestId: string, surveyAnswersId: string) =>
  async (dispatch: any) => {
    try {
      const result = await HttpService.delete(
        `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/guest/${guestId}/survey-answers/${surveyAnswersId}`
      );
      if (result.data) {
        return result.data;
      }
    } catch (e: any) {
      console.log("Error deleting survey answers :", e);
    }
  };

const surveyReducer = createSlice({
  name: "surveys",
  initialState,
  reducers: {
    updateSurvey(state, action: PayloadAction<any>) {
      state.surveysList = action.payload;
    },
    updatePageTotal(state, action: PayloadAction<any>) {
      state.pageTotal = action.payload;
    },
    updatePage(state, action: PayloadAction<any>) {
      state.pageIndex = action.payload;
    },
    updateOrder(state, action: PayloadAction<any>) {
      state.order = action.payload;
    },
    updateOrderAs(state, action: PayloadAction<any>) {
      state.orderAs = action.payload;
    },
    updateSearchSurvey(state, action: PayloadAction<any>) {
      state.search = action.payload;
    },
    updateServerError(state, action: PayloadAction<any>) {
      state.apiError = action.payload;
    },
  },
});

export const {
  updateSurvey,
  updatePageTotal,
  updateOrder,
  updateOrderAs,
  updatePage,
  updateSearchSurvey,
  updateServerError,
} = surveyReducer.actions;

export default surveyReducer.reducer;
